import { Component, Inject, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Utils } from '../../../../utils/utils';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-branchexcellence-changelog-form',
    templateUrl: './branchexcellence-changelog-form.component.html',
    styleUrls: ['./branchexcellence-changelog-form.component.less'],
    standalone: false
})
export class BranchexcellenceChangelogFormComponent implements OnInit {

    public dataSource = new MatTableDataSource<any>();
    isOpenTextAreaOverlay = false;

    columnsToDisplay = ["CreatedBy", "CreatedAtUtc", "ChangedBy", "ChangedAtUtc"];

    constructor(
        private http: HttpClient,
        public dialogRef: MatDialogRef<BranchexcellenceChangelogFormComponent>,
        @Inject('BASE_URL') private baseUrl: string,
        @Inject(MAT_DIALOG_DATA) public data: any, 
        public datePipe: DatePipe,
    ) {
    }

    ngOnInit(): void {
        this.loadChangelog();
    }

    loadChangelog(): void {
        Utils.httpGetBranchExcellenceChangelog(
            this.http,
            this.baseUrl,
            this.data.dataType,
            this.data.id,
            this,
            (tthis: BranchexcellenceChangelogFormComponent, result: any) => {
                const resultArray = [result];
                tthis.dataSource.data = resultArray.map((item: any, index: number) => ({
                    ...item,
                    index: index
                }));
            }
        );
    }

    close(): void {
        this.dialogRef.close();
    }

}